export function GolfPassIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      style={{ stroke: 'none' }}
    >
      <text
        x="1"
        y="18"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="bold"
        fontSize="16"
        letterSpacing="-1"
      >
        <tspan fill="#1b2e4f">G</tspan>
        <tspan fill="#3a82b8">P</tspan>
      </text>
    </svg>
  );
}
